export const ALLOWED_TYPES = [
    "application/pdf",
    "image/png",
    "image/jpeg",
    "image/jpg",
    "image/tiff",
];

export const JOB_TYPE = {
    PARSE: "parse",
    SPLIT: "split",
    TRANSCRIBE: "transcribe",
    DEEP_EXTRACT: "deep_extract",
};

export const JOB_TYPE_LABEL = {
    [JOB_TYPE.DEEP_EXTRACT]: "Deep Extract",
};

export const CHUNK_TYPE_COLOR = {
    text: "#00A3FF",
    table: "#16a34a",
    figure: "#ea580c",
};

export const WORD_BOX_COLOR = "rgba(37,99,235,0.75)";

export const RUN_BUTTON_LABEL = {
    IDLE: "Run",
    PROCESSING: "Processing...",
};

export const MAX_FILE_SIZE = 20 * 1024 * 1024;

export const MIN_FONT_SIZE = 12;
export const MAX_FONT_SIZE = 28;
export const DEFAULT_FONT_SIZE = 16;